






























import Vue from 'vue';
import Slide from '@components/Carousel/Slide.vue';
import Carousel from '@components/Carousel/Carousel.vue';
// The combined cast type -- it's either a show.cast instance or a movie.cast instance
type CombinedCast = Show.Cast | Movie.Cast;

// the cast data interface
interface CastDataInterface {
    castArray: CombinedCast[];
    perPageCount: number;
    currentPage: number;
}

export default Vue.extend({
  components: {
    Slide,
    Carousel
  },
    props: {
        cast: {
            type: Array,
            default: (): CombinedCast[] => ([] as CombinedCast[])
        },
        perPage: {
            type: Number,
            default: 4
        }
    },
    data(): CastDataInterface {
        return {
            // Create a new copy of this array
            castArray: (this.$props.cast.slice(0) || []) as CombinedCast[],
            // number of items per page
            perPageCount: (this.$props.perPage as number),
            currentPage: 1
        };
    },
    methods: {
        buildProfileUri(actor: CombinedCast): string | undefined {
            if(!actor.profile_path) return;
            return this.$tmdb.buildImageUri(actor.profile_path, 'w300');
        }
    },
    computed: {
        currentCast(): CombinedCast[] {
          if(!this.currentPage) return [];
          return (this.castArray as CombinedCast[]).slice((this.currentPage as number-1)* (this.perPageCount as number), (this.currentPage as number) * (this.perPageCount as number));
        },
        totalCastPages(): number {
          const numerator = this.castArray ? (this.castArray as CombinedCast[]).length : 0;
          const denominator = this.perPageCount as number;
          return Math.ceil( numerator / denominator );
        }
    }
});
